import { useLocation } from 'react-router-dom';

export function normalizeSiteBase(raw: string) {
	// normalize to non-www and remove trailing slash
	try {
		let base = raw;
		base = base.replace(/\/\/www\./i, '//');
		base = base.replace(/\/$/, '');
		return base;
	} catch (_err) {
		return raw;
	}
}

export function joinUrl(base: string, path: string) {
	// ensure single slash between base and path
	if (!path) return base;
	if (!base.endsWith('/') && !path.startsWith('/')) return `${base}/${path}`;
	if (base.endsWith('/') && path.startsWith('/')) return `${base}${path.slice(1)}`;
	return `${base}${path}`;
}

// Marketing pages that are affected as per the sheet for SEO directives
export const MARKETING_ROUTES = [
	'/',
	'/about-us',
	'/assessment-service',
	'/assessment-service/candidates',
	'/book-a-demo',
	'/news/tmn-choice-awards-2026',
	'/contact-us',
	'/product',
	'/product/6d-assessment',
	'/resource-download',
	'/resources',
	'/results',
	'/trust-center',
	'/vision'
];


export function useCanonicalUrl() {
	// Fallback to production canonical host if neither is available.
	const envSite = process.env.REACT_APP_SITE_URL || '';
	const runtimeOrigin = typeof window !== 'undefined' ? window.location.origin : '';
	const rawBase = envSite || runtimeOrigin;
	const base = normalizeSiteBase(rawBase);

	return { base };
}

export function useCanonicalUrlWithPath(
  includeQueryParams = false
) {
  const location = useLocation();
  const { base } = useCanonicalUrl();

  const normalizedBase = base.replace(/\/$/, '');
  const normalizedPath = location.pathname.replace(/\/$/, '');

  const query =
    includeQueryParams && location.search
      ? location.search
      : '';

  const canonicalUrl = `${normalizedBase}${normalizedPath || '/'}${query}`;

  return {
    base: normalizedBase,
    canonicalUrl
  };
}
